import { FormConfig, FormValues, Equals, GreaterOrEqualTo } from '@topdanmark-onlinesolutions/claim-form-types';
import { getElementFromElementId } from '../helpers/getElementFromElementId';
import { isDanishDateFormat, convertDateDateToYmd } from '../helpers/dateFuncs';

/**
 * Compare between to date elements
 * @param formConfig
 * @param formValues
 * @param value
 * @param compareElementId
 * @param operator
 * @returns
 */

export const compareDateElements = (
    formConfig: FormConfig | undefined,
    formValues: FormValues | undefined,
    value: string,
    compareElementId: string,
    operator: Equals | GreaterOrEqualTo
) => {
    if (!formConfig) return false;

    const element = getElementFromElementId(formConfig, compareElementId);

    if (element.type !== 'datepicker') {
        throw new Error(`compareDateElements: The element ${compareElementId} is not a date picker!`);
    }

    if (value && formValues && formValues[compareElementId]) {
        if (!isDanishDateFormat(value) || !isDanishDateFormat(formValues[compareElementId])) {
            throw new Error(`compareDateElements: Wrong date format`);
        }

        // Reverse the date string before comparing
        const ymdOtherDate = convertDateDateToYmd(formValues[compareElementId]);
        const ymdCurrentDate = convertDateDateToYmd(value);
        return compareTwoValues(operator, ymdCurrentDate, ymdOtherDate);
    } else {
        return false;
    }
};

const compareTwoValues = (
    operator: Equals | GreaterOrEqualTo,
    value: string | number,
    compareTo: string | number
): boolean => {
    switch (operator) {
        case 'greaterThanOrEqualTo':
            return value >= compareTo;
        case 'greaterThan':
            return value > compareTo;
        case 'isEqualTo':
            return value === compareTo;
        case 'isNotEqualTo':
            return value !== compareTo;
        case 'lessThanOrEqualTo':
            return value <= compareTo;
        case 'lessThan':
            return value < compareTo;
        default:
            return false;
    }
};

export const compareNumberElement = (
    formValues: FormValues | undefined,
    value: string | undefined,
    compareElementId: string,
    operator: Equals | GreaterOrEqualTo
) => {
    throw new Error('Not implemented');
};

export const compareStringElement = (
    formValues: FormValues | undefined,
    value: string | undefined,
    compareElementId: string,
    operator: Equals
) => {
    throw new Error('Not implemented');
};
